module.exports = __webpack_public_path__ + "static/media/logout.0a93939c.png";